import {
  ADD_RECENTLY_VIEWED_CHART,
  RESET_IS_VISIT_CREDIT_UPDATED_SUCCESS,
  RESET_SEARCH_PHARMACY_LIST,
  SET_ERROR,
  SET_IS_ACCOUNT_UPDATED_SUCCESS,
  SET_IS_ALERT_ADDED_SUCCESS,
  SET_IS_ALERTS_LOADED_SUCCESS,
  SET_IS_ALLERGY_ADDED_SUCCESS,
  SET_IS_ALLERGY_DELETED_SUCCESS,
  SET_IS_GENERAL_INFO_UPDATED_SUCCESS,
  SET_IS_PATIENT_INFO_LOADED_SUCCESS,
  SET_IS_PHARMACIES_SEARCHING_DONE,
  SET_IS_PRINTED_VERSION_OF_CHARTS_READY,
  SET_NEW_PATIENTS_LIST,
  SET_PATIENT_PAST_VISITS,
  SET_PATIENT_STATUS_CHANGED_SUCCESS,
  SET_PATIENT_UPCOMING_VISITS,
  SET_PATIENTS_LIST,
  SET_PHONE_VALIDATION,
} from './ChartsConstants'
import { type PatientChartListItem } from '../../pages/patient-charts/types'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientsList = (list) => ({
  type: SET_PATIENTS_LIST,
  payload: list || [],
})
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPhoneValidation = (value, patientId) => ({
  type: SET_PHONE_VALIDATION,
  payload: { value, patientId },
})
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsPrintedVersionReadyToBePrinted = (newValue) => ({
  type: SET_IS_PRINTED_VERSION_OF_CHARTS_READY,
  payload: newValue,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsPatientInfoLoadedSuccess = (value) => ({
  type: SET_IS_PATIENT_INFO_LOADED_SUCCESS,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsAlertsLoadedSuccess = (value) => ({
  type: SET_IS_ALERTS_LOADED_SUCCESS,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsAllergyAddedSuccess = (value) => ({
  type: SET_IS_ALLERGY_ADDED_SUCCESS,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsAllergyDeletedSuccess = (value) => ({
  type: SET_IS_ALLERGY_DELETED_SUCCESS,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsAlertAddedSuccess = (value) => ({
  type: SET_IS_ALERT_ADDED_SUCCESS,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsAccountUpdatedSuccess = (value) => ({
  type: SET_IS_ACCOUNT_UPDATED_SUCCESS,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsGeneralInfoUpdatedSuccess = (value) => ({
  type: SET_IS_GENERAL_INFO_UPDATED_SUCCESS,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setIsPharmaciesSearchingDone = (value) => ({
  type: SET_IS_PHARMACIES_SEARCHING_DONE,
  payload: value || false,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientUpcomingVisits = (patientId, value = []) => ({
  type: SET_PATIENT_UPCOMING_VISITS,
  payload: { patientId, value },
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setPatientPastVisits = (patientId, value = []) => ({
  type: SET_PATIENT_PAST_VISITS,
  payload: { patientId, value },
})

export const resetIsVisitCreditUpdatedSuccess = () => ({
  type: RESET_IS_VISIT_CREDIT_UPDATED_SUCCESS,
  payload: false,
})

export const resetPharmacySearchList = () => ({
  type: RESET_SEARCH_PHARMACY_LIST,
})

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const setChartsError = (value) => ({
  type: SET_ERROR,
  payload: value || '',
})

export const setPatientStatusChangedSuccess = (value = false) => ({
  type: SET_PATIENT_STATUS_CHANGED_SUCCESS,
  payload: value || '',
})

export const setNewPatientsList = (value = null) => ({
  type: SET_NEW_PATIENTS_LIST,
  payload: value,
})

export const addRecentlyViewedChartAction = (chart: PatientChartListItem) => ({
  type: ADD_RECENTLY_VIEWED_CHART,
  payload: chart,
})
